<div
  id="it-multiple-to-account-container"
  class="big-bottom-spacer"
  [formGroup]="parentForm"
>
  <div formArrayName="toAccounts">
    <div *ngFor="let toAccountForm of toAccounts.controls; let i = index">
      <div [formGroupName]="i">
        <div
          [ngClass]="
            i === 0
              ? ['container', 'big-bottom-spacer']
              : ['container', 'big-top-spacer', 'big-bottom-spacer']
          "
        >
          <div id="multiple-to-account-number" class="column-1">
            <label
              class="multiple-to-account-label"
              [class.error-text]="toAccountFormIsInvalid(i)"
              >{{ labelName }}
            </label>
            <input
              id="it-multiple-to-account-number"
              data-testid="it-multiple-to-account-number"
              name="account-number"
              class="sdps-input sdps-input--small"
              [class.error-input]="toAccountFormIsInvalid(i)"
              [attr.disabled]="disabled"
              [disabled]="disabled"
              type="text"
              formControlName="toAccount"
              (focus)="onFocus($event)"
              (keydown)="
                validationService.validateNumberInput(
                  $event,
                  toAccountAllowedChars
                )
              "
              (input)="onInput($event, i)"
              (keydown.enter)="onSubmit(i)"
              (blur)="onSubmit(i, true)"
            />
            <i
              *ngIf="
                isToAccountValid(i) &&
                !(toAccountInContextList[i]?.InContext ?? false)
              "
              class="sch-search"
            ></i>
            <i
              data-testid="clearMultipleAccountIcon"
              *ngIf="isToAccountValid(i) && toAccountInContextList[i].InContext"
              (click)="clearToAccountClicked(i)"
              class="sch-thin-x"
            ></i>
            <div
              class="below-account-container"
              *ngIf="toAccountFormIsInvalid(i)"
            >
              <div class="alert-text" data-testid="multiple-to-account-alert">
                {{ toAccountValidationError(i) }}
              </div>
              <div class="delete-to-account">
                <a
                  class="removeTextV3"
                  *ngIf="toAccounts.controls.length > 1"
                  (click)="deleteToAccount(i)"
                  >Remove</a
                >
              </div>
            </div>
            <a
              class="removeText"
              *ngIf="
                toAccountFormIsInvalid(i) === false &&
                toAccounts.controls.length > 1
              "
              (click)="deleteToAccount(i)"
              >Remove</a
            >
          </div>
          <div id="multiple-to-acccount-registration" class="column">
            <mm-spinner
              *ngIf="(toAccountStates$ | async) && !disabled"
              class="spinner-container"
              [loading]="getToAccountState(getFormIndexValue(i))"
            ></mm-spinner>
            <div
              class="registration-details"
              *ngIf="AccountRegType(i).length > 0 && !accountNumberExists(i)"
              data-testid="multiple-account-registration-data"
            >
              <span id="multiple-to-account-registration-header"
                >Account registration</span
              >
              <span
                class="reg-details-name"
                [ngClass]="{
                  'reg-details-type': !hasReceivingAccountDetails(i)
                }"
                >{{ receivingAccountValue(i) }}</span
              >
              <span
                *ngIf="hasReceivingAccountDetails(i)"
                class="reg-details-type"
                >{{ AccountRegType(i) }}</span
              >
            </div>
          </div>
          <div
            *ngIf="
              toAccountInContextList[i]?.InContext &&
              iraDistributionTypeModelById[getFormIndexValue(i)]
            "
            class="column"
          >
            <mm-select-dropdown-control
              id="itTransactionDetails_IraContributionSelect"
              [parentForm]="toAccount(i)"
              label="'IRA contribution type'"
              [selectModel]="
                iraDistributionTypeModelById[
                  toAccountInContextList[i].toAccount
                ]
              "
              [tooltipVerbiage]="contributionTypeTooltip"
              [suppressEmit]="true"
              class="contributionStartHeight"
            ></mm-select-dropdown-control>
          </div>
          <div
            *ngIf="
              toAccountInContextList[i]?.InContext &&
              (contributionTypeModelById[getFormIndexValue(i)]?.options)!
                .length > 0
            "
            class="column"
          >
            <mm-select-dropdown-control
              id="itTransactionDetails_IraContributionSelect"
              [parentForm]="toAccount(i)"
              label="'IRA contribution type'"
              [selectModel]="
                contributionTypeModelById[toAccountInContextList[i].toAccount]
              "
              [tooltipVerbiage]="contributionTypeTooltip"
              class="contributionStartHeight"
            ></mm-select-dropdown-control>
            <div id="warning" *ngIf="showWarningIRA">
              <div
                id="warning-icon"
                data-testid="warning-icon"
                class="warning-icon-ira"
              ></div>
              <span id="warning-text">IRS 60-day rollover requirement</span>
            </div>
          </div>
          <div
            *ngIf="
              toAccountInContextList[i]?.InContext &&
              toAccountPropertiesById[getFormIndexValue(i)]?.isTrust &&
              !isTrustNonPTRSAccountById[getFormIndexValue(i)]
            "
            class="newRow"
          >
            <mm-it-multiple-trust-fields
              [parentForm]="toAccount(i)"
              [isEdit]="isEdit"
              [datePickerControlName]="datePickerControlName"
              [displayToTrustFields]="true"
            ></mm-it-multiple-trust-fields>
          </div>
        </div>
        <mm-banners
          *ngIf="hasPositionsLotError && failedAccount === getFormIndexValue(i)"
          [type]="'error'"
          [positionsLotFailure]="true"
        ></mm-banners>
        <mm-banners
          *ngIf="
            is401k(i) &&
            this.toAccounts.controls.length > 1
          "
          [htmlStr]="[submit401kSeparatelyError]"
          [type]="'error'"
        ></mm-banners>
        <mm-banners
          *ngIf="
            is401k(i) &&
            !(this.toAccounts.controls.length > 1)
          "
          [htmlStr]="[warningText401kIneligableForEauth]"
          [type]="'warning'"
        ></mm-banners>
        <sdps-divider
          *ngIf="toAccounts.controls.length - 1 !== i"
          variation="tertiary"
        ></sdps-divider>
        <div
          id="add-new-account"
          *ngIf="
            !downloadRequestFormError &&
            toAccounts.controls.length <= toAccountLimit - 1 &&
            toAccounts.controls.length - 1 == i &&
            toAccountInContextList[i]?.InContext &&
            !oneTimeTotalDistSelected &&
            showAddMultipleAccounts &&
            !is401k(i)
          "
        >
          <sdps-divider variation="tertiary"></sdps-divider>
          <a
            (click)="addToAccount()"
            [ngClass]="{ disabled: hasPositionsLotError }"
          >
            <div
              [ngClass]="
                hasPositionsLotError
                  ? ['plus-circle-icon-grey']
                  : ['plus-circle-icon']
              "
            ></div>
            <p class="addAccountText">Add another account</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<sdps-divider variation="secondary" class="big-bottom-spacer"></sdps-divider>
<div class="warmingBanner" *ngIf="showWarningIRA">
  <br />
  <mm-banners
    [htmlStr]="[iraRolloverContributionTypeWarningforMultiple]"
    [type]="'warning'"
  ></mm-banners>
</div>
